import { createSlice } from "@reduxjs/toolkit";
import { createNewCommunityGpt } from "../CommunityAPI/communityApi";

const createNewCommunityGptSlice = createSlice({
  name: "createNewCommunityGpt",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createNewCommunityGpt.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createNewCommunityGpt.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(createNewCommunityGpt.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default createNewCommunityGptSlice.reducer;
